import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Play } from 'lucide-react';
import { companyInfo, stats } from '../data/mock';

const VideoSection = () => {
  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Video Thumbnail */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
            <img 
              src="https://images.unsplash.com/photo-1618371690240-e0d46eead4b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85"
              alt="Security Guard Services"
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-slate-900/50 flex items-center justify-center">
              <a 
                href="https://www.youtube.com/watch?v=BYppzBJ4ux0"
                target="_blank"
                rel="noopener noreferrer"
                className="w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg"
              >
                <Play className="w-8 h-8 text-white fill-white ml-1" />
              </a>
            </div>
            {/* Label */}
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white font-bold text-xl">Security Guard Services</h3>
              <p className="text-gray-300 text-sm">Watch Video</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="bg-slate-800 rounded-xl p-8">
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src="https://images.unsplash.com/photo-1485230405346-71acb9518d9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85"
                  alt="Guard Icon"
                  className="w-16 h-16 rounded-lg object-cover"
                />
                <div>
                  <h3 className="text-3xl font-bold text-orange-500">12,000+</h3>
                  <p className="text-gray-400">Professional Guards</p>
                </div>
              </div>
              
              <p className="text-gray-300 leading-relaxed mb-6">
                {companyInfo.name} is the largest full service national security guard company in the United States. 
                Armed and unarmed guards available 24/7. Call or message us now to get started!
              </p>

              <Link 
                to="/contact"
                className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all hover:shadow-lg"
              >
                Get A Quote Now!
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;